export default {
  viewBox: "0 0 14 12",
  html: "<path d=\"M9 .5H5v11h4zM10 11.5h2.25c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25H10zM1.75.5H4v11H1.75c-.69 0-1.25-.56-1.25-1.25v-8.5C.5 1.06 1.06.5 1.75.5\"/>"
};